// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/video/video.component.scss
// module id = 556
// module chunks = 0